import styled from "styled-components";

export const SignAgreementContainer = styled.div`
  .term {
    font-size: 13px;
    font-weight: 400;
    margin-bottom: 20px;
    margin-top: 0.5rem;
  }

  .radio {
    font-size: 14px;
    font-weight: 400;
  }
`;
